import React, {Component} from 'react';
import SocialNetworks from "../visitors/components/SocialNetworks";

export default class Footer extends Component {
    render() {
        return (
            <footer id="footer">
                <small>&copy; Cutiko</small>

                <div className="small text-links">
                    <SocialNetworks/>
                </div>

            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js